module.exports = __webpack_public_path__ + "static/media/sndvol32_301.b8a9121b.ico";